// make sure to only use this function in event handlers triggered from the browser
// otherwise it will break your server runtime
export function browserRandomId() {
    const uint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
    return uint32.toString(16);
}
